<template lang="pug">
div
  section.u-mt-md
    AppTitle(:title="$t('mantra')")
    .grid.is-widescreen-8.is-desktop-10
      .column
        p.u-text-lg {{$t('mantraDesc')}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec1')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec1Items')")
            h4 {{item.title}}
            p {{item.desc}}
  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec2')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec2Items')")
            h4 {{item.title}}
            p {{item.desc}}
  section.u-mt-md
    AppTitle.u-mb-mi(:title="$t('sec3')" tag="h2")
    .grid
      .column.is-desktop-6
        AppCard(:img="[{ srcset: '{CDN_URL}/base@2x.webp 2x, {CDN_URL}/base.webp 1x', type: 'image/webp' },  { srcset: '{CDN_URL}/base@2x.png 2x, {CDN_URL}/base.png 1x', type: 'image/png' }]" :title="$t('sec3Base')" url="/brand/system" ratio="5:3")

      .column.is-desktop-6
        AppCard(img="https://cdn.baianat.com/works/Cover_1553700128394_ym7rs.png" :title="$t('sec3Blexar')" url="https://www.blexar.com/" ratio="5:3")


  section.u-mt-md.u-mb-md
    AppLink(to="/ordering" :title="$t('cta')" class="button-link is-large " v-html="$t('cta')")

</template>

<script>
export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:image',
          name: 'og:image',
          property: 'og:image',
          content: 'https://cdn.baianat.com/static/share/services.png'
        },
        {
          hid: 'twitter:image',
          name: 'twitter:image',
          property: 'twitter:image',
          content: 'https://cdn.baianat.com/static/share/services.png'
        }
      ]
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Design system creations",
    "pageDesc":"Create custom design systems for your company and get rid of the design and development hassle through a unified design language.",
    "mantra":"Unified experience with |design systems.",
    "mantraDesc":"Create a unified experience for your brand through design systems that scale to match your needs and get your team on the same page.",
    "sec1":"Customizing system elements to your business needs. ",
    "sec1Items":{
      "1":{
        "title":"System components",
        "desc":"Enjoy a custom set of buttons, grids, checkboxes .. etc and distinguish your online presence on website, mobile app and any other attached software."
      },
      "2":{
        "title":"System visuals",
        "desc":"Setting the guidelines for your system visuals including icons, illustrations and graphics to match the rest of the system elements."
      },
      "3":{
        "title":"System guidelines",
        "desc":"Form content voice and tone to accessibility guidelines, we make sure your system matches your overall design mood and feeling."
      }
    },
    "sec2":"Step to the future of design and development.",
    "sec2Items":{
      "1":{
        "title":"Reduce work time",
        "desc":"Get more done in less time using the system pre-designed elements and don’t reinvent the wheel for your brand assets."
      },
      "2":{
        "title":"Get your team along",
        "desc":"Make sure your team are on the same page and fully understands your brand essence and each other related work."
      },
      "3":{
        "title":"Promote consistency",
        "desc":"Enhance your users’ experience through a similar visual language that makes external consistency possible across all the brand platforms."
      }
    },
    "sec3":"Explore Baianat |design systems.",
    "sec3Base":"System",
    "sec3Blexar":"Blexar",
    "cta":"Revolutionize your brand <br> with a design system now."
  },
  "ar": {
    "pageTitle":"أنظمة التصميم",
    "pageDesc":"نساعدك على إنشاء نظام تصميم مخصص لشركتك وتخلص من متاعب التصميم والبرمجة التي تعاني منها في بداية كل مشروع من خلال لغة موحدة.",
    "mantra":"وفر تجارب موحدة |من خلال أنظمة التصميم.",
    "mantraDesc":"قم بإنشاء تجربة موحدة لعلامتك التجارية من خلال أنظمة التصميم التي تتناسب مع احتياجاتك واجعل فريقك على نفس الخط في العمل.",
    "sec1":"خصص عناصر نظام التصميم لاحتياجات عملك.",
    "sec1Items":{
      "1":{
        "title":"مكونات نظام التصميم",
        "desc":"استمتع بمجموعة مخصصة من الأزرار والشبكات والوسوم .... إلخ، وقم بتمييز تواجدك على الإنترنت عبر موقعك أو تطبيقات الجوال وأي برامج أخرى."
      },
      "2":{
        "title":"عناصر نظام التصميم البصرية",
        "desc":"حدد إرشادات العناصر البصرية  للنظام الخاص بك بما في ذلك الأيقونات والرسوم التوضيحية والجرافيك لتتناسب مع بقية عناصر النظام."
      },
      "3":{
        "title":"إرشادات نظام التصميم",
        "desc":"قم بتكوين صوت ونغمة المحتوى وحدد إرشادات إمكانية الوصول، واحرص على تطابق نظامك مع مزاجك واحساسك العام."
      }
    },
    "sec2":"تعرف أكثر على منهج التصميم والبرمجة المستقبلي.",
    "sec2Items":{
      "1":{
        "title":"قلل وقت العمل",
        "desc":"يمكنك إنجاز المزيد في وقت أقل باستخدام عناصر النظام المصممة مسبقًا وعدم إعادة اختراع العجلة لأصول علامتك التجارية."
      },
      "2":{
        "title":"اجمع فريقك على نفس الخط",
        "desc":"تأكد من وجود فريقك على نفس الخط  ويفهم تمامًا جوهر علامتك التجارية وبعض الأعمال الأخرى ذات الصلة بها."
      },
      "3":{
        "title":"تعزيز الثبات",
        "desc":"عزز تجربة المستخدمين من خلال لغة بصرية مماثلة تجعل هناك  ثبات خارجي في جميع المنصات التي تستخدمها العلامة التجارية."
      }
    },
    "sec3":"استكشف أنظمة |تصميم بيانات.",
    "sec3Base":"نظام التصميم",
    "sec3Blexar":"بلكسر",
    "cta":"طور من علامتك التجارية مع  <br> نظام التصميم الآن."
  }
}
</i18n>
